<script>
	import Background from "./Backgrounds.svelte";
	import Chins from "./Chins.svelte";
	import Ears from "./Ears.svelte";
	import Eyes from "./Eyes.svelte";
	import Horns from "./Horns.svelte";
	import Nose from "./Nose.svelte";
	import Face from "./Face.svelte";
	import Mouth from "./Mouth.svelte";
	import Hair from "./Hair.svelte";
	import Bodies from "./Bodies.svelte";
	import Logos from "./Logos.svelte";
	import Paint from "./Paint.svelte";
	import { nameMaker } from "./NameGenerator.svelte";
	import { spring } from "svelte/motion";
	import { fade } from "svelte/transition";
	import { createEventDispatcher } from "svelte";
	import { onMount, tick } from "svelte";

	import {HsvPicker} from 'svelte-color-picker';
	

	import chroma from "chroma-js";
	import ChromaPicker from 'svelte-chroma-picker';

	import { set_input_value } from "svelte/internal";

	export let dataURL;

	const dispatch = createEventDispatcher();

	export let randomize = false;
	export let edit = false;
	export let showbuylink = false;
	export let scalable = false;
	export let w = "400";
	export let h = "600";
	export let dw = "175.32";
	export let dh = "233";
	export let dx = "113"; //translate x
	export let dy = "140"; //translate y
	export let ds = "1"; //scale of head
	export let showbg = true;
	export let showdemon = true;
	export let outline = false;

	//used as variable for randomization
	let display = true;

	let size = spring(1);

	function navigate(event) {
		dispatch("message", {
			hash: hash,
		});
	}

	let scaleVar = 2;

	export let i;

	export let print = false;

	// export let printSizes = {paperWidth: "1826" , paperHeight:"2376", imageWidth: "1007", imageHeight: "1510" , qr: "150"}
	//export let printSizes = {paperWidth: "2380" , paperHeight:"3368", imageWidth: "1600", imageHeight: "2400" , qr: "200"}
	export let printSizes = {
		paperWidth: "612",
		paperHeight: "792",
		imageWidth: "400",
		imageHeight: "600",
		qr: "0",
	};

	// translate values = 415

	// export let baseColor = chroma.hsl(randomNumber(360), 1, .5).hex();
	export let baseColor =
		"rgb(" +
		randomNumber(255) +
		"," +
		randomNumber(255) +
		"," +
		randomNumber(255) +
		")";

	let colors = [];

	function randomHSL(h, s, l) {
		return chroma.hsl(randomNumber(h), s, l).hex();
	}

	function randomNumber(n) {
		return Math.floor(Math.random() * n);
	}

	function randomColor() {
		return chroma.hsl(randomNumber(), 0.7, 0.4);
	}
	function randomBW() {
		return chroma.hsv(330, 0, Math.random() + 0.2);
	}

	function replaceHexHash(str) {
		return str.replace("#", "");
	}

	$: colors = setColors(baseColor);

	function setColors(baseColor) {
		var color = String(baseColor);
		// var  count = color.length;

		// console.log(baseColor)
		// console.log(count)

		//create more options for colors (more dynamic range)

		// var colors =  [
		// 	chroma(color).brighten(3),
		// 	chroma(color).brighten(2),
		// 	chroma(color).brighten(1),
		// 	color,
		// 	chroma(color).darken(1),
		// 	chroma(color).darken(2),
		// 	chroma(color).darken(3),
		// 	"#000",
		// ];

		// use color scale that's more consistent tone on all images.

		var colors 
		
		if (outline == false){
			colors = chroma
			.bezier(["#fff", color, chroma(color).set("hsv.h", "-15"), "#000"])
			.scale()
			.correctLightness()
			.colors(8);

		}else{
			colors = chroma.bezier(["#fff", "#fff"]).scale().colors(7);

		}
		
		return colors;
	}

	let titles = {
		"A": "of the dead",
		"B": "the destroyer",
		"C": "the tiny",
		"D": "the crafty",
		"E": "the blue",
		"F": "the furious",
		"G": "the deciever",
		"H": "the token",
		"I":"the soul eater",
		"J": "the redeemed",
		"K": "the pushover",
		"L": "the quiet",
		"M": "the ruthless",
		"N": "the boneheaded",
		"O": "the theif",
		"P":"the soul sucker",
		"Q":"the tragic",
		"R":"the lonely",
		"S":"the pious",
		"T":"the fool",
		"U":"the white",
		"V":"the black",
		"W":"the red",
		"X":"the bloodless",
		"Y":"the spineless",
		"Z":"the magician",
		"1":"the artist",
		"2":"the handsome",
		"3":"the beautiful",
		"4":"the greater",
		"5":"the lesser",
		"6":"the putrid",
		"7":"the humble",
		"8":"the awesome",		
		"9":"the buttheaded",
		"0":""
	};

	let chins = [
		
		"A",
		"D",		
		"F",
		"G",
		
		
		"J",
		"K",
		"L",
		"M",
		"N",
		"O",
		
		"Q",
		"R",
		
		"T",
		"U",
		"V",
		
		
		"X",
		"Y",
		
	];
	let ears = [
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",
		"M",
		"N",
		"O",
		"P",
		"Q",
		"R",
		"S",
		"T",
		"U",
		"V",
		"W",
		"X",
		"Y",
		"Z",
	];
	let faces = [
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",
		"M",
		"N",
		"O",
		"P",
		"Q",
		"R",
		"S",
		"T",
		"U",
		"V",
		"W",
		"X",
		"Y",
		"Z",
	];
	let eyes = [
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",
		"M",
		"N",
		"O",
		"P",
		"Q",
		"R",
		"S",
		"T",
		"U",
		"V",
		"W",
		"X",
		"Y",
		"Z",
		"1",
	];
	let horns = [
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",
		"M",
		"N",
		"O",
		"P",
		"Q",
		"R",
		"S",
		"T",
		"U",
		"V",
		"W",
		"X",
		"Y",
		"Z",
		"0",
		"1",
	];
	let noses = [
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",
		"M",
		"N",
		"O",
		"P",
		"Q",
		"R",
		"S",
		"T",
		"U",
		"V",
		"W",
		"X",
		"Y",
		"Z",
	];
	let mouths = [
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",		
		"N",
		"O",
		"P",
		"Q",
		"R",
		"S",
		"T",
		"U",
		"V",
		"W",
		"X",
		"Y",
		"Z",
		"1",
		"2",		
		"4",
		"5"
		
	];
	let hairstyles = [
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",		
		"L",
		"O",
		"P",
		"Q",
		"R",
		"S",
		"T",
		"U",
		"W",
		"X",
		"Y",
		
	]; //Z has symbols
	let paints = [
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",
		"M",
		"N",
		"O",
		"P",
		"Q",
		"R",
		"S",
		"T",
		"U",
		"V",
		"W",
		"X"
		
	];
	let backgrounds = [
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",
		"M",
		"N",
		"O",
		"P",
		"Q",
		"R",
		"S",
		"U",
		"V",
		"W",
		"X",
		"Y",
		"Z",
		"1",
		"2",
		"3",
		"4",
		"5",
		"6",
		"7",
		"9",
		"0",
		
	];
	let bodies = [
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",
		"M",
		"N",
		"O",
		"P",
		"Q",
		"R",
		"T",
		"U",
		"V",
		"W",
		"X",
		"Y",
		"Z",		
		"1",
	];
	
	let logos = [
		"A",
		"C",
		"E",
		"H",
		"I",
		"J",
		"K",
		"N",
		"Q",
		"R",
		"S",
		"T",
		"U",
		"V",
		"X",
		"Y",
	];
	let symbols = [
		"0",
		"A",
		"B",
		"C",
		"D",
		"E",
		"F",
		"G",
		"H",
		"I",
		"J",
		"K",
		"L",
	];

	let colorshifts = [
		"0",
		"-30",
		"-60",
		"-90",
		"-180",
		"-240"
	]

	

	export let chin = selectRandom(chins);

	export let ear = selectRandom(ears);
	export let eye = selectRandom(eyes);
	export let horn = selectRandom(horns);
	export let nose = selectRandom(noses);
	export let face = selectRandom(faces);
	export let mouth = selectMouth();


	export let hair = selectRandom(hairstyles);

	export let paint = selectRandom(paints);

	export let bgcode = selectRandom(backgrounds);
	export let body = selectRandom(bodies);

	export let logo =
		Math.floor(Math.random() * 10) == 1 ? selectRandom(logos) : "0";

	export let name = nameMaker();
	export let fname = name.split("-")[0];
	export let lname = name.split("-")[1];
	export let sleep = Math.floor(Math.random() * 10);
	export let sleeping = sleep >= 1 ? false : true;
	export let symbol =
		hair == "Z" || chin == "W" ? selectRandom(symbols) : "0";
	export let bgcolorshift = Math.floor(Math.random()*4);
	export let colorshift = bgcolorshift;
	export let title = "0"

	let chinsetter;

	function selectMouth(){
		let filteredMouths
		if (chin == "X" || chin=="Y"){
			//remove all mouth breathing options from list
			return selectRandom(mouths.filter(function(value){
				return value != "X" && value != "1" && value != "2" && value != "4"
			}))
		}else{
			return selectRandom(mouths)	
		}
		
	}



	export let hash =
		chin +
		ear +
		face +
		paint +
		mouth +
		horn +
		eye +
		nose +
		hair +
		bgcode +
		sleep +
		body +
		logo +
		colorshift+
		bgcolorshift+
		title+
		"-" +
		replaceHexHash(chroma(baseColor).hex()) +
		"-" +
		name +
		"-" +
		symbol
		;
		
	export let encodedhash = encodeURI(btoa(hash));
	let strokeColor = "rgba(0,0,0,1)"
	let strokeWidth = 8 ;
	let svgDownload;

	function selectRandom(array) {
		return array[Math.floor(Math.random() * array.length)];
	}

	function Randomize() {
		display = false;
		baseColor = chroma.hsl(randomNumber(360), 1, 0.5).hex();
		colors = setColors(baseColor);
		tick();

		chin = selectRandom(chins);
		ear = selectRandom(ears);
		face = selectRandom(faces);
		paint = selectRandom(paints);
		mouth = selectRandom(mouths);
		horn = selectRandom(horns);
		body = selectRandom(bodies);
		logo = selectRandom(logos);

		//  horn = "#horn-18";
		eye = selectRandom(eyes);
		nose = selectRandom(noses);
		hair = selectRandom(hairstyles);
		bgcode = selectRandom(backgrounds);
		sleep = Math.floor(Math.random() * 3);
		sleeping = sleep == "1" ? false : true;
		symbol = hair == "Z" ? selectRandom(symbols) : "0";

		colorshift = selectRandom(colorshifts);
		bgcolorshift = colorshift;
		hasTitle = Math.floor(Math.random()*50);
		title = hasTitle <= 1 ? selecteRandom(titles): "";

		hash =
			chin +
			ear +
			face +
			paint +
			mouth +
			horn +
			eye +
			nose +
			hair +
			bgcode +
			sleep +
			body +
			logo +
			colorshift+
			bgcolorshift+
			title+
			"-" +
			replaceHexHash(chroma(baseColor).hex()) +
			"-" +
			name +
			"-" +
			symbol;
			
		setTimeout(() => {
			display = true;
		}, 1000);
	}

	function toggleSleep() {
		sleeping = sleeping ? false : true;
		if (sleeping == false) {
			sleep = 1;
		} else {
			sleep = 0;
		}
	}

	function getNumber(string) {
		return string.match(/\d+/)[0];
	}

	//  A data URL can also be generated from an existing SVG element.

	function linkTo() {
		navigateTo("#/" + hash);
	}

	let svgAsXML;

	onMount(() => {
		if (randomize) {
			// setInterval(Randomize, Math.floor(Math.random() *750) );
			setInterval(Randomize, 5000);
		}

		// console.log ("dataURL="+svgDataURL(svgDownload));
	});

	function svgDataURL(svg) {
		var a = new XMLSerializer().serializeToString(svg);
		return "data:image/svg+xml," + encodeURIComponent(a);
	}

	

	function getColorShift(color, colorshift){
		return chroma("#000").set("hsv.h", colorshift);
	}

	function colorCallback(rgba) {
	console.log(rgba)
}

function setBG(value){
	console.log(value)
 	bgcode = backgrounds[value]
}
function setBody(value){
	console.log(value)
 	body = bodies[value]
}

</script>

{#if edit}
	<div class="w-60">
		<div>
			<h2>Background</h2>
			<button
				on:click={() => {
					bgcode = selectRandom(backgrounds);
				}}
				class="bg-white text-black border">Backgrounds</button>

			<input type="range" min="0" max={backgrounds.length} on:input={e =>setBG(e.target.value)}/>
			<select bind:value={bgcode}>
				{#each backgrounds as bgcode}
					<option value={bgcode}>{bgcode}</option>
				{/each}
			</select>
			
		</div>
		<div>
			<h2>Body</h2>
			<input type="range" min="0" max={bodies.length-1} on:input={e =>setBody(e.target.value)}/>
			<button
				on:click={() => {
					body = selectRandom(bodies);
				}}
				class="bg-white text-black border">Body</button
			>
			<select bind:value={body}>
				{#each bodies as body}
					<option value={body}>{body}</option>
				{/each}
			</select>
			
		</div>

		<div>
			<h2>Chin</h2>
			<button
				on:click={() => {
					chin = selectRandom(chins);
				}}
				class="bg-white text-black">Chin</button
			>
			<select bind:value={chin}>
				{#each chins as chin}
					<option value={chin}>{chin}</option>
				{/each}
			</select>
		
		</div>

		<div>
			<h2>Ears</h2>
			<button
				on:click={() => {
					ear = selectRandom(ears);
				}}
				class="bg-white text-black">Ear</button
			>
			<select bind:value={ear}>
				{#each ears as ear}
					<option value={ear}>{ear}</option>
				{/each}
			</select>
			
		</div>

		<div>
			<h2>Face</h2>
			<button
				on:click={() => {
					face = selectRandom(faces);
				}}
				class="bg-white text-black">Face</button
			>
			<select bind:value={face}>
				{#each faces as face}
					<option value={face}>{face}</option>
				{/each}
			</select>
		</div>

		<div>
			<h2>Paint</h2>
			<button
				on:click={() => {
					paint = selectRandom(paints);
				}}
				class="bg-white text-black">Paint</button
			>
			<select bind:value={paint}>
				{#each paints as paint}
					<option value={paint}>{paint}</option>
				{/each}
			</select>
		</div>

		<div>
			<h2>Eyes</h2>
			<button
				on:click={() => {
					eye = selectRandom(eyes);
				}}
				class="bg-white text-black">Eyes</button
			>
			<select bind:value={eye}>
				{#each eyes as eye}
					<option value={eye}>{eye}</option>
				{/each}
			</select>
		</div>

		<div>
			<h2>Mouth</h2>
			<button
				on:click={() => {
					mouth = selectRandom(mouths);
				}}
				class="bg-white text-black">Mouth</button
			>
			<select bind:value={mouth}>
				{#each mouths as mouth}
					<option value={mouth}>{mouth}</option>
				{/each}
			</select>
		</div>

		<div>
			<h2>Nose</h2>
			<button
				on:click={() => {
					nose = selectRandom(noses);
				}}
				class="bg-white text-black">Nose</button
			>
			<select bind:value={nose}>
				{#each noses as nose}
					<option value={nose}>{nose}</option>
				{/each}
			</select>
		</div>

		<div>
			<h2>Horns</h2>
			<button
				on:click={() => {
					horn = selectRandom(horns);
				}}
				class="bg-white text-black">Horn</button
			>
			<select bind:value={horn}>
				{#each horns as horn}
					<option value={horn}>{horn}</option>
				{/each}
			</select>
		</div>

		<div>
			<h2>Hair</h2>
			<button
				on:click={() => {
					hair = selectRandom(hairstyles);
				}}
				class="bg-white text-black">Hair</button
			>

			<select bind:value={hair}>
				{#each hairstyles as hair}
					<option value={hair}>{hair}</option>
				{/each}
			</select>
		</div>


		<div>
			<h2>ColorShift</h2>
			<button
				on:click={() => {
					colorshift = selectRandom(colorshifts);
				}}
				class="bg-white text-black">Colorshift</button
			>

			<select bind:value={colorshift}>
				{#each colorshifts as colorshift, index}
					<option value={index}>{colorshift}</option>
				{/each}
			</select>
		</div>

		<div>
			<h2>Background ColorShift</h2>
			<button
				on:click={() => {
					colorshift = selectRandom(colorshifts);
				}}
				class="bg-white text-black">BG Colorshift</button
			>

			<select bind:value={bgcolorshift}>
				{#each colorshifts as shift, index}
					<option value={index}>{shift}</option>
				{/each}
			</select>
		</div>


		<div>
			<button on:click={toggleSleep} class="bg-white text-black"
				>Toggle Sleep</button
			>
		</div>

		<div>
			{chin +
					ear +
					face +
					paint +
					mouth +
					horn +
					eye +
					nose +
					hair +
					bgcode +
					sleep +
					body +
					logo +
					colorshift+
					bgcolorshift+
					"-" +
					replaceHexHash(chroma(baseColor).hex()) +
					"-" +
					name +
					"-" +
					symbol}
			
		</div>

		<button on:click={Randomize}> Randomize </button>

		<ChromaPicker bind:color={baseColor} />
		
	</div>
{/if}

{#if dataURL}
	<p>Sorry.</p>
{:else if display == true}

	<svg
		id="demon"
		class="demonbox"
		on:click={navigate}
		viewBox="0 0 {w} {h}"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		overflow="hidden"
		bind:this={svgDownload}
		width={!scalable ? w + "px" : "100%"}
		height={!scalable ? h + "px" : "100%"}
		transition:fade={{ duration: 300 }}
	>
		<!-- -180 sets background to opposite color for testing -->
		<defs>
			<radialGradient
				id="bgShadow{hash}"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate({w / 2} {h /
					1.75}) rotate(90) scale({h / 2} {w / 2})"
			>
				<stop
					stop-color={bgcolorshift == 0 ? chroma(colors[6]) : chroma(colors[6]).set("hsv.h", colorshifts[parseInt(bgcolorshift)]).darken(2)}
				/>
				<stop
					offset="1"
					stop-color={bgcolorshift == 0 ? chroma(colors[5]) : chroma(colors[5]).set("hsv.h", colorshifts[parseInt(bgcolorshift)])}
					stop-opacity="0"
				/>
			</radialGradient>

			<radialGradient
				id="bgGlow{hash}"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate({w / 2} {h /
					1.75}) rotate(90) scale({h / 2} {w / 2})"
			>
				<stop
					stop-color={bgcolorshift == "0" ? chroma(colors[1]) : chroma(colors[1]).set("hsv.h", colorshifts[parseInt(bgcolorshift)]).brighten(1)}
				/>
				<stop
					offset="1"
					stop-color={bgcolorshift == "0" ? chroma(colors[1]) : chroma(colors[1]).set("hsv.h", colorshifts[parseInt(bgcolorshift)])}
					stop-opacity="0"
				/>
			</radialGradient>

			<radialGradient id="bgcolor{hash}">
				<stop
					offset="0%"
					stop-color={bgcolorshift == "0" ? chroma(colors[2]) : chroma(colors[2]).set("hsv.h", colorshifts[parseInt(bgcolorshift)])}
				/>
				<stop
					offset="100%"
					stop-color={bgcolorshift == "0" ? chroma(colors[4]) : chroma(colors[4]).set("hsv.h", colorshifts[parseInt(bgcolorshift)])}
				/>
			</radialGradient>
			
				<linearGradient
				id="smokeGradient{hash}"
				gradientTransform="rotate(90)"
			>
				<stop offset="0" stop-color="rgba(0,0,0,.5)" />
				<stop offset="100%" stop-color="rgba(255,255,255,.1)" />
			</linearGradient>
			
			<linearGradient
				id="linearTopToBottom{hash}"
				gradientTransform="rotate(90)"
			>
				<stop offset="0" stop-color={chroma(colors[6]).alpha(0)} />
				<stop offset="50%" stop-color={chroma(colors[6]).alpha(0)} />
				<stop offset="100%" stop-color={chroma(colors[6]).alpha(0.8)} />
			</linearGradient>


			<filter id="shadow{hash}">
				<feDropShadow
					dx="0"
					dy="0"
					stdDeviation="20"
					flood-color={bgcolorshift == "0" ? chroma(colors[6]) : chroma(colors[6]).set("hsv.h", colorshifts[parseInt(bgcolorshift)])}
				/>
			</filter>

			<filter id="glow{hash}">
				<feDropShadow
					dx="0"
					dy="0"
					stdDeviation="100"
					flood-color={colors[0]}
				/>
			</filter>
			<radialGradient id="noseGradient{hash}" cy="75%">
				<stop offset="0%" stop-color={colors[1]} />
				<stop offset="100%" stop-color={colors[4]} />
			</radialGradient>
			<radialGradient id="faceGradient{hash}">
				<stop offset="0%" stop-color={colors[1]} />
				<stop offset="70%" stop-color={colors[3]} />
				<stop offset="100%" stop-color={colors[5]} />
			</radialGradient>

			<radialGradient id="neckGradient{hash}">
				<stop offset="0%" stop-color={colors[2]} />
				<stop offset="100%" stop-color={colors[4]} />
			</radialGradient>
			<linearGradient
				id="hornGradient{hash}"
				gradientTransform="rotate(40)"
			>
				<stop offset="0" stop-color={colors[0]} />
				<stop offset="100%" stop-color={colors[2]} />
			</linearGradient>
			<linearGradient
				id="hairGradient{hash}"
				gradientTransform="rotate(0)"
			>
				<stop offset="0" stop-color={colors[3]} />
				<stop offset="100%" stop-color={colors[6]} />
			</linearGradient>

			<linearGradient
				id="tongueGradient{hash}"
				gradientTransform="rotate(90)"
			>
			<stop offset="0" stop-color={bgcolorshift == 0 ? chroma(colors[5]) : chroma(colors[5]).set("hsv.h", colorshifts[parseInt(bgcolorshift)])}/>
			<stop offset="20%" stop-color={bgcolorshift == 0 ? chroma(colors[2]) : chroma(colors[2]).set("hsv.h", colorshifts[parseInt(bgcolorshift)])}/>
			<stop offset="100%" stop-color={bgcolorshift == 0 ? chroma(colors[2]) : chroma(colors[1]).set("hsv.h", colorshifts[parseInt(bgcolorshift)])}/>
		
			</linearGradient>

			<linearGradient
				id="eyeGradient{hash}"
				gradientTransform="rotate(90)"
			>
				<stop offset="0" stop-color={colors[5]} />
				<stop offset="20%" stop-color={colors[4]} />
				<stop offset="100%" stop-color={colors[2]} />
			</linearGradient>

			<linearGradient
				id="rainbowGradient{hash}"
				gradientTransform="rotate(90)"
			>
				<stop offset="0" stop-color="rgba(0,0,0,1)" />
				<stop offset="20%" stop-color="rgba(0,0,0,0)" />
				<stop offset="100%" stop-color="rgba(0,0,0,0)" />
			</linearGradient>

			<radialGradient
				id="fireGradient{hash}"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(229.196 491.107) rotate(90) scale(313.009 100.889)"
			>
				<stop stop-color="white" />
				<stop offset="1" stop-color="#FFE500" stop-opacity="0" />
			</radialGradient>

			<radialGradient
				id="bluefireGradient{hash}"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(229.196 491.107) rotate(90) scale(313.009 100.889)"
			>
				<stop stop-color="white" />
				<stop offset="1" stop-color="#FFF" stop-opacity="0" />
			</radialGradient>

			<radialGradient
				id="tshirtGradient{hash}"
				cx="0"
				cy="0"
				r="1"
				gradientUnits="userSpaceOnUse"
				gradientTransform="translate(228.75 973.635) rotate(-1.40866) scale(212.556 289.161)"
			>
				<stop
					offset="0.187834"
					stop-color={colorshift == "0" ? chroma(colors[4]) : chroma(colors[4]).set("hsv.h", colorshifts[colorshift])}
				/>
				<stop
					offset="1"
					stop-color={colorshift == "0" ? chroma(colors[5]) : chroma(colors[5]).set("hsv.h", colorshifts[colorshift])}
				/>
			</radialGradient>

			<!-- <filter width="100%" height="100%" x="0%" y="0%" id="noise">
				<feTurbulence baseFrequency="0.016,0.004" numOctaves="2" seed="0" type="turbulence" >							
					<animate id="noiseAnimate" attributeName="baseFrequency" values="0.016;.02;0.005, .001," from="30" to="0" dur="60s" repeatCount="indefinite" />
				</feTurbulence>
				<feDisplacementMap in="SourceGraphic" in2="turbulence" scale="15" xChannelSelector="R" yChannelSelector="R" />
			</filter> -->

			<filter
				id="softGlow{hash}"
				height="300%"
				width="300%"
				x="-75%"
				y="-75%"
			>
				<!-- Thicken out the original shape -->
				<feMorphology
					operator="dilate"
					radius="4"
					in="SourceAlpha"
					result="thicken"
				/>
				<!-- Use a gaussian blur to create the soft blurriness of the glow -->
				<feGaussianBlur
					in="thicken"
					stdDeviation="10"
					result="blurred"
				/>
				<!-- Change the colour -->
				<feFlood flood-color="rgb(0,186,255)" result="glowColor" />
				<!-- Color in the glows -->
				<feComposite
					in="glowColor"
					in2="blurred"
					operator="in"
					result="softGlow_colored"
				/>
				<!--	Layer the effects together -->
				<feMerge>
					<feMergeNode in="softGlow_colored" />
					<feMergeNode in="SourceGraphic" />
				</feMerge>
			</filter>

			<radialGradient id="bodyL{hash}" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(91.827 914.52) rotate(0.500388) scale(413.047 594.918)">
				<stop stop-color="{colors[2]}"/>
				<stop offset="40%" stop-color={colors[3]} />
				<stop offset="0.967742" stop-color="{colors[6]}" stop-opacity="0"/>
			</radialGradient>
		
			<radialGradient id="bodyR{hash}" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(374.997 939.771) rotate(180) scale(438.283 631.231)">
				<stop stop-color="{colors[2]}"/>
				<stop offset="40%" stop-color={colors[3]} />
				<stop offset="0.967742" stop-color="{colors[6]}" stop-opacity="0"/>
			</radialGradient>

		</defs>

		{#if showbg}
			<g
				on:click={() => {
					bgcode = selectRandom(backgrounds);
				}}
			>
				<Background bind:hash selection={bgcode} colors={colors} />

				<rect
					width={w}
					height={h}
					fill="url(#bgcolor{hash})"
					fill-opacity=".75"
				>
					<!-- <animate attributeName="fill-opacity" from="1" to=".75" dur="1s" begin="2s" repeatCount="1" fill="freeze" />			 -->
				</rect>
			</g>

			<rect
				width={w}
				height={h}
				fill="url(#linearTopToBottom{hash})"
				style="mix-blend-mode:multiply"
			/>

			
		{/if}

		{#if showdemon}

		{#if chin == "X" || chin == "Y"}
				<rect
					width={w}
					height={h}
					fill="url(#bgGlow{hash})"
					style="mix-blend-mode:multiply"
					transform="translate(0,-50)"
				/>
			{:else}
				<rect
					width={w}
					height={h}
					fill="url(#bgShadow{hash})"
					style="mix-blend-mode:multiply"
					transform="translate(75,50)"
				/>
			{/if}
		<g opacity="1" transform="translate({dx} {dy})">
			<g>
				<!-- <animateTransform attributeName="transform" begin="1s" type="translate" dur="1s"  from="-1000,0" to="0,0" repeatCount="1" fill="freeze"/> -->
			<svg
				overflow="visible"
				
				viewbox="0 0 458 615"
				width="{dw}px"
				height="{dh}px"
			>
				<g
					fill="url(#bgcolor)"
					width="100%"
					height="100%"
					stroke="none"
					style="transform-origin:50% 50%;transform:scale({$size});"
				>
					{#if chin == "X" || chin == "Y"}
						<Chins
							selection={chin}
							bind:strokeWidth
							{colors}
							stroke={strokeColor}
							bind:hash
							bind:symbol
						/>
					{/if}

					<Chins back={true} selection={chin}
					bind:strokeWidth
					{colors}
					stroke={strokeColor}
					bind:hash
					bind:symbol />

					<g style="filter:url(#shadow{hash})">
						<Bodies
							selection={body}
							bind:strokeWidth
							{colors}
							stroke={strokeColor}
							bind:hash
						/>

						<!-- {#if body != "A" && body != "B"}
							<Logos
								selection={logo}
								bind:strokeWidth
								{colors}
								stroke={strokeColor}
								bind:hash
							/>
						{/if} -->

						{#if chin != "X" && chin != "Y"}
							<Chins
								selection={chin}
								bind:strokeWidth
								{colors}
								stroke={strokeColor}
								bind:hash
								bind:symbol
							/>
						{/if}
						<Ears
							selection={ear}
							bind:strokeWidth
							{colors}
							bind:hash
							stroke={strokeColor}
						/>
					</g>
					<g style="filter:url(#shadow{hash});">
						<Face
							selection={face}
							bind:strokeWidth
							bind:hash
							{colors}
							stroke={strokeColor}
						/>
					</g>

					<Horns
						selection={horn}
						bind:strokeWidth
						{colors}
						bind:hash
						stroke={strokeColor}
					/>

					<Paint
						selection={paint}
						bind:strokeWidth
						{colors}
						bind:hash
						stroke={strokeColor}
					/>
					<g on:click={toggleSleep} >
						<Eyes
							selection={eye}
							bind:strokeWidth
							{colors}
							bind:hash
							stroke={strokeColor}
							bind:sleeping
						/>
					</g>
					<Mouth
						selection={mouth}
						bind:strokeWidth
						{colors}
						bind:hash
						stroke={strokeColor}
					/>
					<g>
						<Nose
							selection={nose}
							bind:strokeWidth
							bind:hash
							{colors}
							stroke={strokeColor}
						/>
					</g>
					{#if hair == "Z" && chin == "W"}
						<g />
					{:else}
						<Hair
							selection={hair}
							bind:strokeWidth
							{colors}
							bind:hash
							bind:symbol
							stroke={strokeColor}
						/>
					{/if}

					<Bodies
						ontop={true}
						selection={body}
						bind:strokeWidth
						{colors}
						stroke={strokeColor}
						bind:hash
					/>
				
				</g>
			</svg>
		</g>
		</g>
		{/if}
	</svg>

{/if}


{#if showbuylink}
	<p class="py-2 text-xs text-black flex items-center">
		<span class="uppercase font-bold text-left">{fname} {lname}</span>
	</p>
{/if}

<style>
	button,
	select {
		@apply bg-white border px-2 py-2 rounded;
	}

	.demonbox {
		position: relative;
		width: 100%;
		margin: 0;
		padding: 0;
		display: flex;
	}
	.demonbox:hover {
		z-index: 100;
	}
	h2 {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 20px;
		font-size: 10px;
		color: white;
		letter-spacing: 0.25em;
		text-align: center;
		text-transform: uppercase;
	}

	.svgtext {
		font-size: 12px;
		font-weight: bold;
		color: white;
		letter-spacing: 0.25em;
		text-align: center;
		text-transform: uppercase;
	}

	.downloadButton {
		position: absolute;
		margin: 0;
		padding: 0;
		right: 20px;
		bottom: 20px;
	}

	
	
	/* :global(path){
		filter: drop-shadow(0px 0px 5px rgb(0 0 0 / .2));
	} */

	@media only screen and (min-device-width: 320px) and (max-device-width: 480px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
		h2 {
			position: absolute;
			left: 0;
			right: 0;
			bottom: 20px;
			font-size: 10px;
			font-size: 12px;
			text-align: center;
			color: #fff;
			font-weight: normal;
			letter-spacing: 0.25em;
			text-transform: uppercase;
		}
	}

	@media only print {
		.downloadButton {
			display: none;
		}
	}
</style>
